import type { CoverSlideData } from "./types";

/** Placeholder cover shown before any real trip/checklist data is loaded. */
export const EMPTY_COVER: Partial<CoverSlideData> = {
  kickerText: "FIELD DIARY",
  headlineTitle: "Your headline",
  subtitle: "LOCATION · MONTH YEAR",
  stats: [
    { icon: "📍", value: "Location" },
    { icon: "🕐", value: "0:00" },
    { icon: "🐦", value: "0 species" },
    { icon: "📅", value: "Month" },
  ],
};
